<template>
  <div class="freez-action-col" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon v-if="params.Status != 'Accepted'"
      icon="CheckCircleIcon"
      title="Confirmed"
      svgClasses="h-5 w-5 mr-4 text-success cursor-pointer"
      @click="changeStatus('Accepted',params.id)"
    />
    <feather-icon v-if="!['Canceled','Rejected'].includes(params.Status)"
      icon="MinusCircleIcon"
      title="Cancelled"
      svgClasses="h-5 w-5 mr-4 text-primary cursor-pointer"
      @click="changeStatus('Cancelled',params.id)"
    />
    <feather-icon v-if="!['Canceled','Rejected'].includes(params.Status)"
      icon="SlashIcon"
      title="Rejected"
      svgClasses="h-5 w-5 mr-4 text-warning cursor-pointer"
      @click="changeStatus('Rejected',params.id)"
    />
    <feather-icon 
      icon="Trash2Icon"
      title="Delete"
      svgClasses="h-5 w-5 text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
    
  </div>
</template>

<style scoped>
/*.switch-publish {
}*/
</style>
<script>
import Swal from "sweetalert2";
export default {
  name: "CellRendererActions",
  data: {
    //IsPublished: false
  },
  watch: {
    "params.data.IsPublished"() {
      debugger;
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("roundtableManagement/updateStatus", {
          id: this.params.id,
          IsPublished: this.params.data.IsPublished
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  methods: {
    editRecord(id) {
      //console.log(id);
      //id = window.btoa(id);
      this.$router
        .push({
          name: "roundtable-edit",
          params: {
            roundtableId: id
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    changeStatus(status, id){
       this.$vs.loading();
      this.$store.dispatch("meetingManagement/changeStatus", {id:id, status: status})
        .then((res)   => { 
          if(res.status == 200)
            this.showChangeStatusSuccess();
          else
          {
            this.$vs.notify({
              color: "warning",
              //title: "Status Changed",
              text: "Something went wrong!"
            });
          }

          this.$vs.loading.close();
         })
        .catch(err => { 
          console.error(err) 
          this.$vs.loading.close();      
        })
    },
    confirmDeleteRecord() {
                   const { value: text } = Swal.fire({
          title: "Are you sure you want to delete this meeting?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecord();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      this.$vs.loading();
      this.$store.dispatch("meetingManagement/removeRecord", [this.params.id])
        .then((res)   => { 
          this.$vs.loading.close(); 
          if(res.status == 200)
            this.showDeleteSuccess() 
          else
          {
            this.$vs.notify({
              color: "warning",
              //title: "Status Changed",
              text: "Something went wrong!"
            });
          }
        })
        .catch(err => { 
          console.error(err)     
          this.$vs.loading.close();   
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Deleted",
        text: "The selected record was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
};
</script>
